import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.scss";
// import App from './App';
import { AppRoutes } from "./app/routes/AppRoutes";
import reportWebVitals from "./reportWebVitals";
import "./setup/translations/i18next";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import "./resources/assets/sass/style.scss";
import "react-toastify/dist/ReactToastify.css";
import "./styles/tailwind.css";
import "./styles/css/sidebar-layout.css";
import "./styles/css/selected-product.css";

import axios from "axios";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "../src/setup/redux/store";
import { SENTRY_RELEASE } from "./config/sentry";
import GlobalContextProvider from "./context/globalContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ToastContainer } from "react-toastify";
import * as Log from "src/util/SDayslogger";
import { env, enableDebugMode } from "./config/env";

// firebases.firestore();

Sentry.setContext("User", {
  name: "Bryan Test",
  noHP: "081XXXXXXXXX",
  session: "abcakrlqwrhiqwrhietheittiuewityeiwytiw",
});

//https://71472c638ab145dd8e1d8ed5ff042d87@o1218588.ingest.sentry.io/6360592
Sentry.init({
  // dsn: "https://71472c638ab145dd8e1d8ed5ff042d87@o1218588.ingest.sentry.io/6360592",
  dsn: env.SENTRY_DSN,
  integrations: [new BrowserTracing()],
  autoSessionTracking: true,
  beforeSend(event, hint) {
    // Check if it is an exception, and if so, show the report dialog
    if (event.exception) {
      Sentry.showReportDialog({
        eventId: event.event_id,
        title: "Sepertinya anda sedang mengalami kendala.",
        subtitle: "Tim kami akan segera menangani.",
        subtitle2:
          "Sampaikan kendala atau masalah yang anda alami di bawah ini.",
        labelName: "Nama",
        labelComments: "Apa kendala anda?",
        labelClose: "Tutup",
        labelSubmit: "Kirim",
      });
    }
    return event;
  },

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  // release: 'Testing-Sentry@',
  release: SENTRY_RELEASE,
});

// Increase default timeout for WhatsApp API calls which can be slow
axios.defaults.timeout = parseInt(env.REQUEST_TIMEOUT);

Log.debug(`Env DEBUG ${env.DEBUG} DEBUG: ${enableDebugMode}`);

if (env.NODE_ENV !== "development" && !enableDebugMode) {
  console.log(`log removed`);
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

export const queryClient = new QueryClient();

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <GlobalContextProvider>
      <ThemeProvider>
        <React.StrictMode>
          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                }}
              >
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            }
          >
            <Provider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                <AppRoutes />
                <ToastContainer
                  bodyStyle={{ fontFamily: "Poppins", fontWeight: 400 }}
                />
              </PersistGate>
            </Provider>
          </Suspense>
        </React.StrictMode>
      </ThemeProvider>
    </GlobalContextProvider>
  </QueryClientProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
